import type { ReactNode } from 'react';
import { Button } from './Button.js';

export interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  description?: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmationDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancel',
  destructive = false,
  onConfirm,
  onCancel,
}: ConfirmationDialogProps) {
  if (!open) return null;
  return (
    <div className="ui-dialog-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="ui-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ui-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="ui-dialog-title" style={{ margin: '0 0 0.5rem', fontSize: '1.25rem' }}>
          {title}
        </h2>
        {description ? (
          <div style={{ marginBottom: '1rem', color: 'var(--3ds-text-secondary)', lineHeight: 1.5 }}>
            {description}
          </div>
        ) : null}
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <Button variant="ghost" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={destructive ? 'danger' : 'primary'} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
